const api = process.env.VUE_APP_API_URL;
export const base_roar = api + "v1/roar";
